export default __webpack_public_path__ + "static/media/notif.25a4c677.png";